import styled from '@emotion/styled'
import { Block } from 'components/Block'
import { Picture } from 'components/picture/Picture'
import { HStack, Stack } from 'components/Stack'
import { Caption, Title } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SCaption = styled(Caption)`
  @media ${BREAKPOINTS.MD.max} {
    text-align: center;
  }
`

export const STitle = styled(Title)`
  @media ${BREAKPOINTS.MD.max} {
    text-align: center;
  }
`

export const SSocialHStack = styled(HStack)`
  grid-area: social;
  color: var(--c-gray500);

  & a,
  & a:visited {
    color: inherit;
    display: flex;
  }
`

export const SBlock = styled(Block)`
  padding-bottom: 2rem;
  @media ${BREAKPOINTS.LG.min} {
    padding-top: 6rem;
  }
`

export const STitleSocialStack = styled(Stack)`
  @media ${BREAKPOINTS.MD.max} {
    align-items: center;
  }
`

export const SPicture = styled(Picture)`
  width: 520px;
  margin-right: -40px;

  @media ${BREAKPOINTS.LG.max} {
    width: ${pxToRem(400)}rem;
  }
  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
    max-width: ${pxToRem(400)}rem;
  }
`
